import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withAuthorization from '../Session/withAuthorization';
import { db } from '../../firebase';
import firebase from 'firebase';
import HomeTable from './HomeTable';
import Form from "react-jsonschema-form";
import '../css/forms.css';

const UserList = ({ users }) =>
  <div className="">
  {
    Object.keys(users).map(key => 
      <div>
        {key === "password" || key === "id"?  null : <div key={key}><span className="detail_key">{key} -</span> {users[key]}</div> }
      </div>
    )
  }
  </div>

class HomePage extends Component {
  constructor(props){
    super();
    this.state = {
      data : '',
      modalIsOpen : false,
      formType :  '',
      formPath : '',
      modal : false,
      formData : [],
      admin : false
    }
  }
  
  componentWillMount() {
    var uid = firebase.auth().currentUser.uid , self = this;
    firebase.database().ref('users/admin/details').once('value',function(snap){
      if(snap.hasChild(uid)){
        self.setState({
          admin : true
        })
        self.props.history.push('/admin');
      }
    })
    const { onSetUsers , onTable} = this.props;
    db.onceGetUsers().then(snapshot =>
      onSetUsers(snapshot.val())
    );
  }

  render() {
    var { users } = this.props ;

    return (
      <div className="display_home">
        <div style={{width : '100%'}}>
          <div className="col-sm-12 col-md-12 col-lg-12 home_card">
            {users ? <div className="welcome_user m-t-20">Welcome back {users['name']}</div> : null}
            <div className="col-sm-6 col-md-6 col-lg-6 home_detail">
              <div className="col-sm-6 col-md-6 col-lg-6 card_details">
                {users ? !!users && <UserList users={users} /> : null }
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 m-t-20">
            <HomeTable uid= {firebase.auth().currentUser.uid}/>
          </div>  
        </div>
      </div>
    );
  }
} 

const mapStateToProps = (state) => ({
  users: state.userState.users,
});

const mapDispatchToProps = (dispatch) => ({
  onSetUsers: (users) => dispatch({ type: 'USERS_SET', users })
});

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  connect(mapStateToProps, mapDispatchToProps)
)(HomePage);
